import { ConnectMessagePageData } from '../interfaces/connect-message-page-model.interface';

export const CREDIT_DENIED_MESSAGE: ConnectMessagePageData = {
  title: '¡Ups! Hoy no podemos otorgarte el crédito para tu compra.',
  subtitle: 'Esto podría cambiar. Inténtalo la próxima vez.',
  content: undefined,
  buttonText: 'Entendido',
  showFooter: false
};

export const GENERIC_ERROR_MESSAGE: ConnectMessagePageData = {
  title: '¡Ups, algo salió mal!',
  subtitle: 'Parece que hubo un problema. Intenta otra vez y todo debería funcionar.',
  content: 'Si sigue fallando, revisa tu conexión o vuelve más tarde.',
  buttonText: 'Intenta de nuevo',
  showFooter: false
};

export const OUT_OF_BUSINESS_HOURS_MESSAGE: ConnectMessagePageData = {
  title: 'Estamos fuera del horario hábil para estudiar tu solicitud.',
  subtitle: 'Intenta nuevamente entre las <b>4:00am</b> y las <b>10:00pm</b>.',
  content: undefined,
  buttonText: 'Regresar',
  showFooter: true
};
